import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import routes from './routes';
import createBrowserHistory from './helpers/History';
import './App.scss';
import { connect } from 'react-redux';
import { useEffect } from 'react';
import { checkUserTokenRequestAction,loginActionData } from './store/user/userActions';
import { getStoredToken, getStoredUser, isAuthenticated } from './helpers/userHelper';
import MainLayout from './layouts/MainLayout/MainLayout';
import PublicLayout from './layouts/PublicLayout/PublicLayout';
import NotFound from './pages/NotFound/NotFound';
const keys = Object.keys(routes);

function App({ ...props }) {
  const { setLoginData,checkUserToken } = props;
  useEffect(() => {
    const user = getStoredUser();
    if (user) setLoginData(user);
    const token = getStoredToken();
    if (token) checkUserToken();
    
  }, []);
  return (
    <Router history={createBrowserHistory}>
      <Switch>
        {keys.map((layoutName, layoutIndex) => {
          let layout = routes[layoutName];
          return routes[layoutName].children.map((route, index) => {
            return (
              <route.routeComponent
                key={index}
                exact={route.exact}
                path={route.path}
                render={(props) => (
                  <layout.component {...props}>
                    <route.component {...props} />
                  </layout.component>
                )}
              />
            );
          });
        })}
        <Route
          path="*"
          render={(props) => {
            const LayoutComponent = isAuthenticated() ? MainLayout : PublicLayout;
            return (
              <LayoutComponent {...props}>
                <NotFound {...props} />
              </LayoutComponent>
            );
          }}
        />
      </Switch>
    </Router>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    setLoginData: (payload) => {
      dispatch(loginActionData({ result: payload }));
    },
    checkUserToken: (payload) => {
      dispatch(checkUserTokenRequestAction(payload));
    },
  };
};

export default connect(null, mapDispatchToProps)(App);
